import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapAutocomplete = React.lazy(function () { return import('../../bootstrap-components/components/BTAutocomplete'); });
var bootStrapAutocomplete = function (props) {
    return (React.createElement(BootStrapAutocomplete, __assign({ styleName: props.hasError ? 'danger' : props.styleName }, props)));
};
export var Autocomplete = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapAutocomplete(props);
            break;
        default:
            componentToDisplay = bootStrapAutocomplete(props);
            break;
    }
    return (React.createElement("div", null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Autocomplete.defaultProps = {
    styleName: 'primary',
    label: 'Autocomplete',
    ioTheme: themes[0],
    options: [{ value: 'ocean', label: 'Ocean' }, { value: 'blue', label: 'Blue' }, { value: 'purple', label: 'Purple' }]
};
//# sourceMappingURL=Autocomplete.js.map